<template>
    <div class="card">

        <tabs v-model="selectedTab">
            <tab class="tab" v-for="(tab, i) in tabs" :key="`t${i}`" :val="tab" :label="tab" :indicator="true" />
        </tabs>


        <tab-panels v-model="selectedTab" :animate="true">
            <tab-panel style="height:100%">
                <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
                <div v-if="selectedTab == 'Dashboard'" style="margin-top:20px;height:100%;">
                    <div class="grid">
                        <div class="col-12 xl:col-3">
                            <div class="card" style="background-color: #D5ECFC;height:100%" >
                                
                                <b><center>Visits</center></b>
                                <hr>
                                <center>
                                    <b><VueGauge title="Visits" value="35000" rangeLabel="100000" /></b>
                                </center>
                                <b><center style="margin-top:10px">Today's Visits : 35000</center></b>

                            </div>
                        </div>
                        <div class="col-12 xl:col-3">
                            <div class="card" style="background-color: #D5ECFC;height:100%">

                                <b><center>Vehicles</center></b>
                                <hr>
                                <center>
                                    <b><VueGauge title="Vehicles" value="28000" rangeLabel="40000" /></b>
                                </center>
                                <b><center style="margin-top:10px">Today's Active Vehicle : 28000</center></b>

                            </div>
                        </div>
                        <div class="col-12 xl:col-3">
                            <div class="card" style="background-color: #D5ECFC; height:100%">
                                
                                <b><center>BreakDown Vehicles</center></b>
                                <hr>
                                <center>
                                    <Chart type="pie" :data="chartData1" :options="chartOptions1" class="w-full md:w-11rem" />
                                </center><br>
                                <b><center style="margin-top:10px">Total Breakdown vehicles : 2365</center></b>

                            </div>
                        </div>
                        <div class="col-12 xl:col-3">
                            <div class="card" style="background-color: #D5ECFC; height:100%">
                                
                                <b><center>Vehicles</center></b>
                                <hr>
                                <center>
                                    <Chart type="pie" :data="chartData3" :options="chartOptions3" class="w-full md:w-11rem" />
                                </center><br>
                                <b><center style="margin-top:10px">Total vehicles : 40000</center></b>

                            </div>
                        </div>
                    </div>
                    <!-- ====================================================================================== -->
                    <div class="grid">
                        <div :class="{ 'col-12': true, 'xl:col-6': !isZoomed, 'xl:col-12': isZoomed }" v-if="!isZoomed1">

                            <div class="card" style="background-color: #D5ECFC;" @click="toggleZoom">
                                <center>
                                    <b>Last 30 Days Visits</b>
                                    <hr>
                                    <Chart type="bar" :data="chartData" :options="chartOptions" class="h-20rem" />
                                    <b>Visited Home/Total Homes</b>
                                </center>
                            </div>

                        </div>
                        <div :class="{ 'col-12': true, 'xl:col-6': !isZoomed1, 'xl:col-12': isZoomed1 }" v-if="!isZoomed">
                            <div class="card" style="background-color: #D5ECFC;" @click="toggleZoom1">
                                <center>
                                    <b>Last 30 Days Active Vehicles</b>
                                    <hr>
                                    <Chart type="bar" :data="chartData2" :options="chartOptions2" class="h-20rem" />
                                    <b>Vehicle with Ride/Total Vehicles</b>
                                </center>
                            </div>
                        </div>
                    </div>
                    <!-- ====================================================================================== -->
                    <div class="grid">
                        <div class="col-12 xl:col-4">
                            <div class="card">
                                <DataTable ref="dt4" :value="Top_village" class="p-datatable-sm" :rows="10"
                                    responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="id"
                                    :rowHover="true" showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Villages (top 10)</h5>
                                        </div>
                                    </template>
                                    <Column field="top_village_name" header="Village Name" style="width:80%">
                                        <template #body="{ data }">
                                            <span>{{ data.village_name }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                                        <template #body="{ data }">
                                            <span>{{ data.Visits }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                        <div class="col-12 xl:col-4">
                            <div class="card">
                                <DataTable ref="dt4" :value="Top_cluster" class="p-datatable-sm" :rows="10"
                                    responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="id"
                                    :rowHover="true" showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Clusters (top 10)</h5>
                                        </div>
                                    </template>
                                    <Column field="cluster_name" header="Clusters Name" style="width:80%">
                                        <template #body="{ data }">
                                            <span>{{ data.cluster_name }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                                        <template #body="{ data }">
                                            <span>{{ data.Visits }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                        <div class="col-12 xl:col-4">
                            <div class="card">
                                <DataTable ref="dt4" :value="Top_districts" class="p-datatable-sm" :rows="10"
                                    responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="id"
                                    :rowHover="true" showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Districts (top 10)</h5>
                                        </div>
                                    </template>
                                    <Column field="districts_name" header="Districts Name" style="width:80%">
                                        <template #body="{ data }">
                                            <span>{{ data.districts_name }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                                        <template #body="{ data }">
                                            <span>{{ data.Visits }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <div class="grid">
                        <div class="col-12 xl:col-4">
                            <div class="card">
                                <DataTable ref="dt4" :value="Bottom_village" class="p-datatable-sm" :rows="10"
                                    responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="id"
                                    :rowHover="true" showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Villages (Bottom 10)</h5>
                                        </div>
                                    </template>
                                    <Column field="village_name" header="Village Name" style="width:80%">
                                        <template #body="{ data }">
                                            <span>{{ data.village_name }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                                        <template #body="{ data }">
                                            <span>{{ data.Visits }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                        <div class="col-12 xl:col-4">
                            <div class="card">
                                <DataTable ref="dt4" :value="Bottom_cluster" class="p-datatable-sm" :rows="10"
                                    responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="id"
                                    :rowHover="true" showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Clusters (Bottom 10)</h5>
                                        </div>
                                    </template>
                                    <Column field="cluster_name" header="Clusters Name" style="width:80%">
                                        <template #body="{ data }">
                                            <span>{{ data.cluster_name }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                                        <template #body="{ data }">
                                            <span>{{ data.Visits }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                        <div class="col-12 xl:col-4">
                            <div class="card">
                                <DataTable ref="dt4" :value="Bottom_districts" class="p-datatable-sm" :rows="10"
                                    responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="id"
                                    :rowHover="true" showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Districts (Bottom 10)</h5>
                                        </div>
                                    </template>
                                    <Column field="districts_name" header="Districts Name" style="width:80%">
                                        <template #body="{ data }">
                                            <span>{{ data.districts_name }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                                        <template #body="{ data }">
                                            <span>{{ data.Visits }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>








                </div>
                <div v-if="selectedTab == 'Live Ride Tracking Dashboard'" style="margin-top:20px;">
                    <div class="col-12 lg:col-6 lg:col-12" style="padding:0!important;width:100%;height:700px"
                        v-if="home == true">
                        <InputText type="text" placeholder="Mobile Number" v-model="search_key"
                            v-on:keyup.enter="search_people">
                        </InputText>
                        &nbsp;
                        <InputText type="text" placeholder="name" v-model="name" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="City" v-model="city" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="State" v-model="state" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="Pincode" v-model="pincode" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="Vehicle Number" v-model="vehicle_number"
                            v-on:keyup.enter="search_people">
                        </InputText>&nbsp;&nbsp;

                        <Dropdown id="status" filter style="width:180px" v-model="routeitem" :options="routeitems"
                            :value="routeitems.value" optionLabel="name" placeholder="Select Route" required="true"
                            @change="search_people"></Dropdown>&nbsp;
                        <Dropdown v-if="user_key && (user_key == 'Admin' || user_key == 'admin')" style="width:180px"
                            id="state" v-model="client_id_search" filter placeholder="Select Client"
                            :options="client_id_dropdown" optionLabel="name" :optionValue="value" @change="search_people">
                        </Dropdown>
                        &nbsp;
                        <Button icon="pi pi-search" @click="search_people"
                            class="p-button-rounded p-button-primary mt-2" />&nbsp;
                        <Button icon="pi pi-refresh" @click="reset_search_people"
                            class="p-button-rounded p-button-primary mt-2" />
                            <div style="text-align:right;font-weight:bold">
                        <!-- <span>Total Rides:</span>{{ travellist_filter.length}} -->
                        <Button @click="ride_list" type="button" label="Live Ride" icon="pi pi-car" :badge="travellist_filter.length>0?travellist_filter.length:'0'" badgeClass="p-badge-danger" outlined  :disabled="travellist_filter.length==0"/>
                        </div>
                        <hr>

                        <!-- <GoogleMap api-key="AIzaSyA62nfiBf_7XngEJxzZxltpRMbJjd2f7Fg" style="width: 100%; height: 85%" :center="center" :zoom="5"> -->
                        <GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 800px"
                            :center="center" :zoom="5">

                            <MarkerCluster>

                                <Marker v-for="(location, i) in travellist_filter" :options="{ position: location }"
                                    :key="i">
                                    <InfoWindow>
                                        <div id="contet" style="width:450px">
                                            <div id="siteNotice"></div>

                                            <div id="bodyContent" class="grid" style="font-size:11px;width:600px">

                                                <div class="col-3 lg:col-3 lg:col-3">

                                                    <img :src="location.profile_image"
                                                        style="width:100px;border-radius:70%" />
                                                </div>
                                                <div class="col-9 lg:col-9 lg:col-9"  style="font-size:15px;">

                                                    <!-- <b>Commuter Name :</b> {{ location.commuter_name }}
                                                    <br>
                                                    <b>Mobile Number :</b> {{ location.mobile_number }}
                                                    <br>
                                                    <b>Latitude :</b> {{ location.lat }} <b>Longitude :</b> {{ location.lng
                                                    }}
                                                    <br>
                                                    <b>Place Details :</b><br> <span>{{ location.place_add }}</span><br> -->

                                                    <b>Driver Name :</b> {{ location.driver_name }}
                                                    <br><b>Driver Mobile Number :</b> {{ location.driver_mobile_number }}
                                                    <br><b>Village Name :</b> {{ location.village_name }}

                                                </div>
                                                <p>

                                                </p>
                                                <p style="width:300px">
                                                </p>
                                                <p>

                                                </p>
                                                <p>
                                                </p>

                                                <Button label="View details" @click="view_details(location)"
                                                    class="p-button-info p-button-sm	 mr-2 mb-2" />


                                            </div>
                                        </div>
                                    </InfoWindow>

                                </Marker>
                            </MarkerCluster>
                        </GoogleMap>



                    </div>
                    <div class="col-12 lg:col-6 xl:col-8" v-if="home == false"
                        style="padding:0!important;width:100%;height:700px">
                        <Button style="text-align-right" label="Back" @click="back_map()"
                            class="p-button-info p-button-sm	 mr-2 mb-2" />

                        <GoogleMapDashboard :center1="center1" :lat="center1.lat" :lng="center1.lng"
                            :centerstart="centerstart" :polyline="polyline" :polypath="polypath" />

                    </div>
                    <Dialog header="Ride Details" v-model:visible="ride_productDialog" :breakpoints="{ '960px': '75vw' }"
                        :style="{ width: '70vw' }" :modal="true">
                        <DataTable ref="ride_dt" :value="travellist_filter" class="p-datatable-sm" :rows="10"
                              responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="sr_no"
                              :rowHover="true" showGridlines>
                              <template #header>
                                    <div
                                          class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                          <h5 class="m-0">Live Ride List</h5>
                                         
                                                <Button icon="pi pi-upload" v-tooltip.bottom="'Export'" @click="exportCSV2" />
                                         
                                    </div>
                                    <div style="text-align: right; font-weight: bold">
                                          <span>Total :</span>{{ travellist_filter.length }}
                                    </div>
                              </template>
                              <template #empty> No Record found. </template>
                              <Column header="Profile"  style="text-align:center;">
                                    <template #body="{ data }">
                                    <img  :src="data.profile_image" 
                                            :alt="data.profile_image" 
                                            v-if="data.profile_image" 
                                            class="shadow-2"
                                            width="50">
                                    <img  v-else
                                            src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                                            class="shadow-2"
                                            width="50"
                                    />
                                    </template>
                                </Column>
                                <Column field="vehicle_registrationNumber" header="Vehicle No" sortable style="min-width: 3rem">
                                    <template #body="{ data }">
                                          <span>{{ data.vehicle_registrationNumber }}</span>
                                    </template>
                              </Column>
                              <Column field="driver_name" header="Driver Name" sortable style="min-width: 3rem">
                                    <template #body="{ data }">
                                          <span>{{ data.driver_name }}</span>
                                    </template>
                              </Column>
                              <Column field="driver_mobile_number" header="Mobile Number" sortable style="min-width: 3rem">
                                    <template #body="{ data }">
                                          <span>{{ data.driver_mobile_number }}</span>
                                    </template>
                              </Column>
                              <Column field="village_name" header="Village Name" sortable style="min-width: 3rem">
                                    <template #body="{ data }">
                                          <span>{{ data.village_name }}</span>
                                    </template>
                              </Column>
                              <Column header="View Details" headerStyle="min-width:5rem;">
                                <template #body="{ data }">
                                    <Button
                                        icon="pi pi-eye"
                                        v-tooltip.bottom="'View Details'"
                                        class="p-button-rounded p-button-success mr-2"
                                        @click="view_details(data)"
                                        size="small"
                                    />
                                </template>
                            </Column>
                              
                        </DataTable>
                  </Dialog>
                </div>
                <div v-if="selectedTab == 'Solid Waste'" style="margin-top:20px;height:100%;">
                    <solid_waste/>
                </div>
                <div v-if="selectedTab == 'Plastic'" style="margin-top:20px;height:100%;">
                    <plastic/>
                </div>
                <div v-if="selectedTab == 'Fical'" style="margin-top:20px;height:100%;">
                    <fical/>
                </div>

            </tab-panel>
        </tab-panels>

    </div>
</template>
  
<script>
import EventBus from '@/AppEventBus';
import ProductService from '../service/ProductService';
import apis from "@/apis";
import axios from "axios";
import { Buffer } from 'buffer'
import { embedDashboard } from "@superset-ui/embedded-sdk";
import GoogleMapComponent from '../components/GoogleMap'
import superset_dashboard from '../components/superset_dashboard'

import GoogleMapDashboard from '../components/GoogleMapDashboard'


import Map from "mapmyindia-react";
import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs';

import SocketioService from "../service/socketio.service.js";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { GoogleMap, Marker, MarkerCluster, InfoWindow, Polyline } from "vue3-google-map";
import socketioService from '../service/socketio.service.js';
// import Superset_dashboard from './superset_dashboard.vue';
// embedDashboard({
//   id: "f151aeed-6800-42fb-befc-9a4dd719ff0b", // given by the Superset embedding UI
//   supersetDomain: "http://192.168.1.22:8088/",
//   mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
//   fetchGuestToken: () => fetchGuestTokenFromBackend(),
//   dashboardUiConfig: { // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
//       hideTitle: true,
//       filters: {
//           expanded: true,
//       }
//   },
// });
import VueGauge from '../components/VueGauge'
import solid_waste from '../components/solid_waste'
import plastic from '../components/plastic'
import fical from '../components/fical'




export default {
    data() {
        return {
            ride_productDialog: false,
            isZoomed: false,
            isZoomed1: false,

            chartData1: null,
            chartOptions1: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            },
            chartData3: null,
            chartOptions3: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            },
            //--------------------------------------------------------------
            chartData: null,
            chartOptions: null,
            chartData2: null,
            chartOptions2: null,

            //---------------------------------------------------------------
            Top_village: [
                { village_name: 'Palghar', Visits: 98 },
                { village_name: 'Thane', Visits: 97 },
                { village_name: 'Kalyan', Visits: 96 },
                { village_name: 'Bhiwandi', Visits: 96 },
                { village_name: 'Diva', Visits: 95 },
                { village_name: 'Vasai', Visits: 93 },
                { village_name: 'Andheri', Visits: 92 },
                { village_name: 'Dadar', Visits: 91 },
                { village_name: 'karjat', Visits: 90 },
                { village_name: 'kasara', Visits: 89 },

            ],
            Top_cluster: [
                { cluster_name: 'Cluster Name 1', Visits: 99 },
                { cluster_name: 'Cluster Name 2', Visits: 97 },
                { cluster_name: 'Cluster Name 3', Visits: 95 },
                { cluster_name: 'Cluster Name 4', Visits: 94 },
                { cluster_name: 'Cluster Name 5', Visits: 94 },
                { cluster_name: 'Cluster Name 6', Visits: 93 },
                { cluster_name: 'Cluster Name 7', Visits: 92 },
                { cluster_name: 'Cluster Name 8', Visits: 91 },
                { cluster_name: 'Cluster Name 9', Visits: 90 },
                { cluster_name: 'Cluster Name 10', Visits: 89 },

            ],
            Top_districts: [
                { districts_name: 'Amravati', Visits: 97 },
                { districts_name: 'Sangli', Visits: 96 },
                { districts_name: 'Satara', Visits: 96 },
                { districts_name: 'Solapur', Visits: 95 },
                { districts_name: 'Kolhapur', Visits: 95 },
                { districts_name: 'Pune', Visits: 94 },
                { districts_name: 'Akola', Visits: 93 },
                { districts_name: 'Buldhana', Visits: 92 },
                { districts_name: 'Yavatmal', Visits: 92 },
                { districts_name: 'Washim', Visits: 91 },

            ],
            Bottom_village: [
                { village_name: 'Panvel', Visits: 20 },
                { village_name: 'Swawood', Visits: 30 },
                { village_name: 'khandeshwar', Visits: 40 },
                { village_name: 'Mansarovar', Visits: 45 },
                { village_name: 'Nerul', Visits: 45 },
                { village_name: 'Sanpada', Visits: 47 },
                { village_name: 'Vashi', Visits: 48 },
                { village_name: 'Mankhurd', Visits: 49 },
                { village_name: 'Turbhe', Visits: 49 },
                { village_name: 'Ghansoli', Visits: 51 },

            ],
            Bottom_cluster: [
                { cluster_name: 'Cluster Name 1', Visits: 20 },
                { cluster_name: 'Cluster Name 2', Visits: 35 },
                { cluster_name: 'Cluster Name 3', Visits: 40 },
                { cluster_name: 'Cluster Name 4', Visits: 41 },
                { cluster_name: 'Cluster Name 5', Visits: 42 },
                { cluster_name: 'Cluster Name 6', Visits: 43 },
                { cluster_name: 'Cluster Name 7', Visits: 43 },
                { cluster_name: 'Cluster Name 8', Visits: 44 },
                { cluster_name: 'Cluster Name 9', Visits: 45 },
                { cluster_name: 'Cluster Name 10', Visits: 48 },

            ],
            Bottom_districts: [
                { districts_name: 'Beed', Visits: 20 },
                { districts_name: 'Jalna', Visits: 25 },
                { districts_name: 'Dharashiv', Visits: 28 },
                { districts_name: 'Nanded', Visits: 29 },
                { districts_name: 'Latur', Visits: 32 },
                { districts_name: 'Parbhani', Visits: 33 },
                { districts_name: 'Hingoli', Visits: 35 },
                { districts_name: 'Bhandara', Visits: 36 },
                { districts_name: 'Chandrapur', Visits: 36 },
                { districts_name: 'Gadchiroli ', Visits: 38 },

            ],


            fullPage: true,
            user_key: "",
            client_id_dropdown: [],
            client_id_search: '',
            routeitem: '',
            routeitems: [],
            isLoadingModel: false,
            pieOptions: null,
            tabs: ['Dashboard','Live Ride Tracking Dashboard','Solid Waste','Plastic','Fical'],

            selectedTab: "Dashboard",
            pieData: {},
            pieData1: {},
            center: { lat: 19.0626704, lng: 73.005094 },
            center1: {},
            centerstart: {},
            polyline: [
            ],
            polyline1: [
            ],
            polypath: {
                // path: this.polyline,
                // geodesic: true,
                // strokeColor: '#FF0000',
                // strokeOpacity: 1.0,
                // strokeWeight: 2,
            },

            search_key: "",
            home: true,
            random: 0,
            token: '',
            get_date: "",
            get_date_2: "",
            locations1: [],
            locations: [
                { lat: 19.0626704, lng: 73.005094, name: "Prathamesh" },
                { lat: 28.38, lng: 77.12, name: "Sanjay" }

            ],
            markers: [
                {
                    position: [18.5314, 73.845],
                    draggable: true,
                    title: "Marker title"
                }]
            ,
            messages: [],
            inputMessageText: "",

            form: {
                roomName: "63a939f2b319a2f01eb75798",
                userName: "639c6caae0aa678e9f6de543",
            },
            products: null,
            todayslectures: [],

            dashcount: {
                "riders": 0,
                "drivers": 0,
                "driverowner": 0,
                "vehicles": 0,
                "owners": 0,
                "admin": 0,
                "travels": 0,
                "schools": 0,
                "alerts": 0,
                "today_alerts": 0,
                "today_travels": 0,
                "school_buses": 0,
                "pending_alerts": 0,
                "routes": 0,
                "stops": 0
            },
            // center: [37,7749, -122,4194],

            lineData: {
                labels: ['0', '0 to 20', '20 to 40', '40 to 60', '60 to 80', '80 to 100'],
                datasets: [
                    {
                        label: 'Network',
                        data: [],
                        backgroundColor: '#00bb7e',

                    },
                    // {
                    // 	label: 'Sales',
                    // 	data: [],
                    // 	fill: false,
                    // 	backgroundColor: '#00bb7e',
                    // 	borderColor: '#00bb7e',
                    // 	tension: 0.4
                    // }
                ]
            },
            travellist: [],
            travellist_filter: [],
            lastNumber: 1,

            barData: {
                labels: [],
                height: "150px",
                datasets: [
                    {
                        label: 'Total Rides',
                        backgroundColor: '#2f4860',
                        data: []
                    }
                ]
            },
            barData1: {
                labels: [],
                datasets: [
                    {
                        label: 'No Of Lectures by Teacher',
                        backgroundColor: '#2f4860',
                        data: []
                    }
                ]
            },
            barOptions: null,
            barOptions1: null,
            items: [
                { label: 'Add New', icon: 'pi pi-fw pi-plus' },
                { label: 'Remove', icon: 'pi pi-fw pi-minus' }
            ],
            lineOptions: null,
        }
    },
    productService: null,
    themeChangeListener: null,

    async mounted() {
        // this.load_map();


        // this.productService.getProductsSmall().then(data => this.products = data);
        this.themeChangeListener = (event) => {
            if (event.dark)
                this.applyDarkTheme();
            else
                this.applyLightTheme();
        };
        EventBus.on('change-theme', this.themeChangeListener);

        if (this.isDarkTheme()) {
            this.applyDarkTheme();
        }
        else {
            this.applyLightTheme();
        }

        // this.get_date=new Date();
        // this.datausagereport();
        // this.get_date_2=new Date();
        //  await this.setupLeafletMap();
        await this.gettodaysTravelList();
        // this.networkconnectivityreport();
        // this.todayslecturereport();
        // this.teacherlecturereportadmin();
        //   this.timer = setInterval(() => {
        // 	 this.getrandomLatlong( this.getRandNumber())
        // }, 1000)
        // this.pieOptions = {
        // 		plugins: {
        // 			legend: {
        // 				labels: {
        // 					color: '#495057'
        // 				}
        // 			}
        // 		}
        // 	};
        // alert(this.dashcount.drivers)



        this.chartData = this.setChartData();
        this.chartOptions = this.setChartOptions();
        this.chartData2 = this.setChartData2();
        this.chartOptions2 = this.setChartOptions2();
        this.chartData1 = this.setChartData1();
        this.chartData3 = this.setChartData3();


    },
    beforeUnmount() {
        EventBus.off('change-theme', this.themeChangeListener);
    },
    async created() {
        window.Buffer = window.Buffer || Buffer

        // alert(this.token)
        //         supersetEmbeddedSdk.embedDashboard({
        //   id: "f151aeed-6800-42fb-befc-9a4dd719ff0b", // given by the Superset embedding UI
        // supersetDomain: "http://192.168.1.22:8088/",
        // mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
        // fetchGuestToken: () =>  this.token,
        // dashboardUiConfig: { // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
        //      hideTitle: true,
        //     // filters: {
        //     //     expanded: true,
        //     // }

        //   }});

        // this.load_map();
        this.productService = new ProductService();
        this.user_key = localStorage.getItem("user_key");
        await this.dashboardcount();
        await this.dashboardRideData();
        await this.route_list();
        await this.get_client_list();
        await this.get_pending_alert_count();
        // await this.superset_api();
        // this.load_map_superset();
        // var token=await this.superset_api();
        // alert(this.token);


        // this.load_map();

    },
    watch: {
        selectedTab() {
            if (this.selectedTab == "Dashboard") {
                // this.load_map_superset();
            }
        },
        polyline() {
            alert('ok');
            this.home = true;
            this.home = false;
        }
    },
    methods: {
        async ride_list()
        {
            this.ride_productDialog=true;
        },
        async exportCSV2()
        {
            await this.$refs.ride_dt.exportCSV();
        },
        toggleZoom() {
            this.isZoomed = !this.isZoomed;
        },
        toggleZoom1() {
            this.isZoomed1 = !this.isZoomed1;
        },
        setChartData1() {


            return {
                labels: ['Flat or faulty battery', 'Lost keys', 'Damaged tyres and wheels', 'Overheating', 'Fuel problems'],
                datasets: [
                    {
                        data: [540, 325, 702, 220, 84],
                        backgroundColor: ['#6366F1', '#EADA41', '#3DCC5B', 'black', '#FF5454'],
                        hoverBackgroundColor: ['#FF5454', 'pink', '#F77275', '#EADA41', '#3DCC5B']
                    }
                ]
            };
        },
        setChartData3() {


            return {
                labels: ['Battery Operated Garbage Vehicle', 'Garbage Cycle'],
                datasets: [
                    {
                        data: [28000, 12000 ],
                        backgroundColor: ['#EADA41', '#3DCC5B'],
                        hoverBackgroundColor: ['#F77275', 'pink']
                    }
                ]
            };
            },

        setChartData() {


            return {
                //labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                labels: ["1-6-2023", "2-6-2023", "3-6-2023", "4-6-2023", "5-6-2023", "6-6-2023", "7-6-2023", "8-6-2023", "9-6-2023", "10-6-2023", "11-6-2023", "12-6-2023", "13-6-2023", "14-6-2023", "15-6-2023", "16-6-2023", "17-6-2023", "18-6-2023", "19-6-2023", "20-6-2023", "21-6-2023", "22-6-2023", "23-6-2023", "24-6-2023", "25-6-2023", "26-6-2023", "27-6-2023", "28-6-2023", "29-6-2023", "30-6-2023"],

                datasets: [
                    {
                        type: 'bar',
                        label: 'Visited Home',
                        backgroundColor: '#173EA3',
                        data: [75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 78124, 76982]

                    },
                    {
                        type: 'bar',
                        label: 'Total Homes',
                        backgroundColor: '#FF5454',
                        data: [100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000]

                    },

                ]
            };
        },
        setChartData2() {


            return {
                //labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                labels: ["1-6-2023", "2-6-2023", "3-6-2023", "4-6-2023", "5-6-2023", "6-6-2023", "7-6-2023", "8-6-2023", "9-6-2023", "10-6-2023", "11-6-2023", "12-6-2023", "13-6-2023", "14-6-2023", "15-6-2023", "16-6-2023", "17-6-2023", "18-6-2023", "19-6-2023", "20-6-2023", "21-6-2023", "22-6-2023", "23-6-2023", "24-6-2023", "25-6-2023", "26-6-2023", "27-6-2023", "28-6-2023", "29-6-2023", "30-6-2023"],

                datasets: [
                    {
                        type: 'bar',
                        label: 'Vehicle With Ride',
                        backgroundColor: '#173EA3',
                        data: [20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 21254, 25487]
                    },
                    {
                        type: 'bar',
                        label: 'Total Vehicles',
                        backgroundColor: '#FF5454',
                        data: [40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000]
                    },

                ]
            };
        },
        setChartOptions() {

            //stackdata
            // return {
            //     maintainAspectRatio: false,
            //     aspectRatio: 0.8,
            //     plugins: {
            //         tooltips: {
            //             mode: 'index',
            //             intersect: false
            //         },
            //         legend: {
            //             labels: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     },
            //     scales: {
            //         x: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         },
            //         y: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     }
            // };

            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                    legend: {
                        labels: {
                            fontColor: '#908fa8'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#908fa8',
                            font: {
                                weight: 500
                            }
                        },
                        grid: {
                            display: false,
                            drawBorder: false
                        }
                    },
                    y: {
                        ticks: {
                            color: '#908fa8'
                        },
                        grid: {
                            color: '#908fa8',
                            drawBorder: false
                        }
                    }
                }
            };
        },
        setChartOptions2() {


            // return {
            //     maintainAspectRatio: false,
            //     aspectRatio: 0.8,
            //     plugins: {
            //         tooltips: {
            //             mode: 'index',
            //             intersect: false
            //         },
            //         legend: {
            //             labels: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     },
            //     scales: {
            //         x: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         },
            //         y: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     }
            // };
            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                    legend: {
                        labels: {
                            fontColor: '#908fa8'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#908fa8',
                            font: {
                                weight: 500
                            }
                        },
                        grid: {
                            display: false,
                            drawBorder: false
                        }
                    },
                    y: {
                        ticks: {
                            color: '#908fa8'
                        },
                        grid: {
                            color: '#908fa8',
                            drawBorder: false
                        }
                    }
                }
            };
        },



        getaltimage() {
            return "https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o=";
        },
        reset_search_people() {
            this.search_key = '';
            this.name = '';
            this.city = '';
            this.state = '';
            this.pincode = '';
            this.vehicle_number = '';
            this.routeitem = '';
            this.client_id_search = '';

        },
        search_people() {

            if (this.search_key || this.name || this.city || this.state || this.pincode || this.vehicle_number || this.routeitem.value || this.client_id_search.value) {
                // alert(1);
                this.gettodaysTravelList();
            }
        },
        uniqueAssociativeArray(array) {
            let uniqueArray = {};

            for (let i = 0; i < array.length; i++) {
                let currentElement = array[i];
                if (!uniqueArray[currentElement]) {
                    uniqueArray[currentElement] = true;
                }
            }
            return Object.keys(uniqueArray);
        },
        filterAssociativeArray(arr, key, values) {
            var result = arr.filter(function (a) {
                return values.indexOf(a[key]) !== -1;
            });
            return result;
        },
        gettodaysTravelList() {
            this.isLoadingModel = true;
           const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[]; 
            var data = {
                "route_id": this.routeitem.value,
                //"search_client":this.client_id_search.value,
                "mobile_number": this.search_key,
                "city": this.city,
                "pincode": this.pincode,
                "state": this.state,
                "vehicle_number": this.vehicle_number,
                "name": this.name,
                "client_id": this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id"),
                "client_group_ids":client_group_ids,
            }
            var promise = apis.todaysTravelListDashboard(data);
            promise
                .then(response => {
                    // alert(1);
                    this.isLoadingModel = false;
                    this.travellist = response.data.data;
                    for (var i = 0; i < this.travellist.length; i++) {
                        this.travellist[i].lat = parseFloat(this.travellist[i].lat);
                        this.travellist[i].lng = parseFloat(this.travellist[i].lng);
                    }
                    this.travellist_filter = this.travellist;
                }).catch((error) => {
                    //console.log(error);
                    this.isLoadingModel = false;
                    // this.$swal.fire(error.response.data);

                })
                ;
        },


        submitMessage() {
            const CHAT_ROOM = this.form.roomName;
            const message = this.inputMessageText;
            SocketioService.sendMessage({ message, roomName: CHAT_ROOM }, (cb) => {
                console.log(cb);
                this.messages.push({
                    message,
                    ...SENDER,
                });
                // clear the input after the message is sent
                this.inputMessageText = "";
            });
        },
        async submitToken() {

            console.log(this.form);
            let header = {
                "Access-Control-Allow-Origin": "*",
                "content-type": "application/json",
            };
            let Promise = axios.post("http://65.1.73.254:8090/", this.form, {
                header: header,
            });

            Promise.then((res) => {
                if (res.status == 200) {
                    console.log(res);
                    this.token = res.data.token;
                    //   alert(this.token);
                    SocketioService.setupSocketConnection(this.token);
                    SocketioService.subscribeToMessages((err, data) => {
                        console.log("position data", data);
                        this.messages.push(data);
                        data = JSON.parse(data)
                        // console.log(JSON.parse(data));
                        // this.center1.lat=data.lat;
                        // this.center1.lng=data.lng;
                        this.center1 = { "lat": data.lat, "lng": data.lng }
                        this.polyline.push(this.center1);
                        localStorage.setItem('polyline', this.polyline);
                        this.polyline1 = new google.maps.Polyline(this.polyline).getPath();
                        console.log(this.polyline1)
                        this.random = this.random + 1;
                        this.polypath = {
                            path: this.polyline,
                            geodesic: true,
                            strokeColor: 'blue',
                            strokeOpacity: 1.0,
                            strokeWeight: 2,
                        }

                    });
                }
            });
        },
        get_pending_alert_count() {
            var data = {
                id: localStorage.getItem("id"),
                count: true,
                unread: false,
                mobile_number: '',
                status: 0,
                from_date: new Date().toISOString().split('T')[0],
                to_date: new Date().toISOString().split('T')[0],
                type: "ride sos alert",
                client_id: localStorage.getItem("client_id")
            };

            var promise = apis.sosAlertMaster(data);
            promise.then((response) => {

                console.log(response);
                this.dashcount.pending_alerts = response.data.data;

            });

        },
        getRandNumber() {
            var x = Math.floor((Math.random() * 214) + 1); // get new random number

            if (x === this.lastNumber) { // compare with last number
                return this.getRandNumber() // if they are the same, call the function again to repeat the process
            }
            return x // if they're not the same, return it
        },
        getRideData(id) {

            var data = { ride_id: id };
            var promise = apis.getRideDataLive(data);
            promise
                .then(response => {
                    this.list = [];
                    this.list = response.data;

                    if (this.list.length > 0) {
                        var length = this.list.length;

                        this.center = { lat: parseFloat(this.list[0].lat), lng: parseFloat(this.list[0].lng) };
                        this.center1 = { lat: parseFloat(this.list[length - 1].lat), lng: parseFloat(this.list[length - 1].lng) };

                        var data = [];
                        for (let x = 0; x < length; x++) {
                            if (this.list[x].lat && this.list[x].lng) {
                                data.push({ lat: parseFloat(this.list[x].lat), lng: parseFloat(this.list[x].lng) });
                            }

                        }
                        //this.polypath = {path:data}
                        this.polypath = {
                            path: data,
                            geodesic: true,
                            strokeColor: 'blue',
                            strokeOpacity: 0.5,
                            strokeWeight: 5,
                        }

                    }


                }
                )

        },

        async view_details(location) {

            // this.center1= await this.getrandomLatlong(await this.getRandNumber());
            console.log(123, await this.getRandNumber());
            this.home = false;
            this.centerstart = { lat: location.lat, lng: location.lng }

            //await  mapRef.value.map.panTo({ lat: 0, lng: lng.value });
            // alert(location._id)
            this.form.roomName = location._id;
            this.form.userName = location.user_id;
            // this.polyline.push(location);
            this.getRideData(location._id);
            await this.submitToken();
            // await this.submitMessage();
        },
        back_map() {
            this.home = true;
            socketioService.disconnect();
        },
        show_route() {
            var screensize = document.querySelectorAll("#maph")
            screensize[0].style.display = "none";
            screensize[0].style.display = "block";
            this.show_map = false;
            this.show_map = true;
            this.home = true;
            this.home = false;
        },
        get_location_details(location) {
            // alert(location.name)
        },
        setupLeafletMap: function () {
            const mapDiv = L.map("mapContainer").setView([37, 7749, -122, 4194], 13);
            L.tileLayer(
                "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
                {
                    attribution:
                        'Map data (c) <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery (c) <a href="https://www.mapbox.com/">Mapbox</a>',
                    maxZoom: 18,
                    id: "mapbox/streets-v11",
                    token: "sk.eyJ1IjoicHJhdGhhbWVzaDExMDkiLCJhIjoiY2xidzBzZnVxMXB4ODNwcWRkOGRqOGluaiJ9.4K08iC1KLCqL6MOFcioywg",
                }
            ).addTo(mapDiv);

        },
        load_map() {
            // let btn = document.getElementById('map');
            map = '';

            var map = new MapmyIndia.Map("map", { center: [28.09, 78.3], zoom: 5, search: false });

        },
        go_to_user_route() {
            this.$router.push('/groupmaster');

        },
        go_to_driver() {
            this.$router.push('/usermaster');
            localStorage.driver = 'Driver';

        },
        go_to_vehicle() {
            this.$router.push('/vehiclemaster');
        },
        goto_alert() {
            this.$router.push('/sosalertmaster');
            localStorage.alert = 'alert';
        },
        go_to_rider() {
            this.$router.push('/ridemaster');
        },
        go_to_route() {
            this.$router.push('/groupmaster');
        },
        go_to_subject() {
            this.$router.push('/usermaster');
        },
        go_to_Notice() {
            this.$router.push('/NoticeMaster');
        },
        //-----------------------------------

        route_list() {
            var data = {

                count: false,
                client_id: localStorage.getItem("client_id") ? localStorage.getItem("client_id") : ''

            };
            this.loading = true;
            var promise = apis.group_list(data, this.id);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data.length > 0) {

                    response.data.data
                        .filter(item => item.name)
                        .map(item => this.routeitems.push({ name: item.name, value: item._id }));

                }
            });
        },
        get_client_list() {
            var data = { count: false };
            var promise = apis.getclientist(data);
            promise.then((response) => {
                if (response.data.data) {
                    response.data.data
                        .filter(item => item.client_name)
                        .map(item => this.client_id_dropdown.push({ name: item.client_name, value: item._id }));
                }
            });
        },


        async dashboardRideData() {
            var data = { client_id: localStorage.getItem("client_id") ? localStorage.getItem("client_id") : '' };
            var promise = apis.dashboardRideData(data);
            promise
                .then(response => {
                    this.barData.labels = response.data.data.series;
                    this.barData.datasets[0].data = response.data.data.data;
                });
        },
        async dashboardcount() {
            var data = { client_id: localStorage.getItem("client_id") ? localStorage.getItem("client_id") : '' };
            var promise = apis.clientDashboard(data);
            promise
                .then(response => {

                    var other_data = response.data.other_data;
                    this.dashcount.today_travels = other_data.todays_travel;

                    this.dashcount.travels = other_data.total_travel;
                    this.dashcount.schools = other_data.schools;
                    this.dashcount.school_buses = other_data.school_buses;
                    this.dashcount.alerts = other_data.alerts;
                    this.dashcount.today_alerts = other_data.todays_alerts;
                    this.dashcount.vehicles = other_data.vehicles;
                    this.dashcount.routes = other_data.routes;
                    this.dashcount.stops = other_data.stops || 0;
                    var data = response.data.data;




                    for (var i = 0; i < data.length; i++) {

                        if (data[i].user_type == 'Driver') {
                            this.dashcount.drivers += data[i].count;
                        }
                        if (data[i].user_type == 'Owner') {
                            this.dashcount.owners += data[i].count;
                        }
                        if (data[i].user_type == 'Rider') {
                            this.dashcount.riders += data[i].count;
                        }
                        if (data[i].user_type == 'Driver Owner') {
                            this.dashcount.driverowner = data[i].count;
                        }
                        if (data[i].user_type == 'Admin') {
                            this.dashcount.admin = data[i].count;
                        }

                    }
                    // if(i==(count-1))
                    // {
                    // alert('here');
                    // alert(this.dashcount.riders);
                    // alert(i);
                    this.dashcount.alerts = response.data.other_data.alerts;
                    this.dashcount.today_alerts = response.data.other_data.todays_alerts;
                    this.pieData = {
                        labels: response.data.other_data.user_counts.labels,
                        datasets: [
                            {
                                data: response.data.other_data.user_counts.series_data,
                                backgroundColor: [
                                    "#F04136",
                                    "#2B3890",
                                    "#F7941E",
                                    "#F9ED32",
                                    "#D7F422",
                                    "#DE6BBC",
                                    "#DEDD59",
                                    "#58DEDF"
                                ],
                                hoverBackgroundColor: [
                                    "#FF6384",
                                    "#36A2EB",
                                    "#FFCE56",
                                    "#662D91",
                                    "#F8F194",
                                    "#58DEDF",
                                    "#949597",
                                    "#F8F194"

                                ]
                            }
                        ]
                    };
                    this.pieData1 = {
                        labels: response.data.other_data.vehicle_group.labels,
                        datasets: [
                            {
                                data: response.data.other_data.vehicle_group.series_data,
                                backgroundColor: [
                                    "#F04136",
                                    "#2B3890",
                                    "#F7941E",
                                    "#39B54A",
                                    "#D7F422",
                                    "#DE6BBC",
                                    "#DEDD59",
                                    "#58DEDF"
                                ],
                                hoverBackgroundColor: [
                                    "#FF6384",
                                    "#36A2EB",
                                    "#FFCE56",
                                    "#662D91",
                                    "#F8F194",
                                    "#58DEDF",
                                    "#949597",
                                    "#DEDD59"
                                ]
                            }
                        ]
                    };
                    // }


                    // this.dashcount=response.data;
                });

        },
        networkconnectivityreport() {
            var D = new Date(this.get_date_2);

            if (this.get_date_2) {
                var date = D.toLocaleDateString("en-US", { year: "numeric" }) + "-" + D.toLocaleDateString("en-US", { month: "2-digit" }) + "-" + D.toLocaleDateString("en-US", { day: "2-digit" });
            }
            var data = { date: date };
            var promise = apis.networkconnectivityreport(data);
            promise
                .then(response => {
                    this.lineData.datasets[0].data = Object.values(response.data);
                });

        },
        datausagereport() {
            var D = new Date(this.get_date);

            if (this.get_date) {
                var date = D.toLocaleDateString("en-US", { year: "numeric" }) + "-" + D.toLocaleDateString("en-US", { month: "2-digit" }) + "-" + D.toLocaleDateString("en-US", { day: "2-digit" });
            }
            var data = { date: date };
            var promise = apis.dashboarddatausagereport(data);
            promise
                .then(response => {
                    // alert(1);
                    // console.log(this.barData.datasets[0].data);
                    this.barData.datasets[0].data = Object.values(response.data);
                });

        },
        teacherlecturereportadmin() {
            var promise = apis.teacherlecturereportadmin();
            promise
                .then(response => {
                    // alert(1);
                    // console.log(this.barData.datasets[0].data);
                    this.barData1.labels = response.data.teacher;

                    this.barData1.datasets[0].data = response.data.lectures;
                });

        },
        todayslecturereport() {
            var data = {
                "limit": 5,
                "page_no": 1
            }

            var promise = apis.todayslecturereport(data);
            promise
                .then(response => {
                    // alert(1);
                    // console.log(this.barData.datasets[0].data);
                    this.todayslectures = response.data;
                });

        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        isDarkTheme() {
            return this.$appState.darkTheme === true;
        },
        applyLightTheme() {
            this.barOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    },

                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                }
            };
            this.barOptions1 = {
                indexAxis: 'y',
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                }
            };
            this.lineOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                }
            };
        },
        applyDarkTheme() {
            this.lineOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#ebedef'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#ebedef'
                        },
                        grid: {
                            color: 'rgba(160, 167, 181, .3)',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#ebedef'
                        },
                        grid: {
                            color: 'rgba(160, 167, 181, .3)',
                        }
                    },
                }
            };
        }
    },
    components: {
        Tabs,
        Tab,
        TabPanels,
        superset_dashboard,
        GoogleMapDashboard,
        TabPanel,
        GoogleMap, Marker, MarkerCluster, InfoWindow, Polyline, GoogleMapComponent,
        "l-map": LMap,
        LTileLayer,
        LMarker,
        VueGauge,
        solid_waste,
        plastic,
        fical

    }
}
</script>
<style>
/* .layout-topbar,.layout-sidebar{ */
/* background-color:#173EA3 !important;
  }
  .layout-topbar .layout-topbar-button{
    color: white;
  }
  .layout-menu li a{
    color: white;
  }
  .layout-topbar-logo a{
    color: white;
  } */
/* .layout-main-container{
      background-color: black !important;
  }
  .layout-wrapper{
      background-color: black !important;
  } */
</style>
<style scoped>
#mapContainer {
    width: 100%;
    height: 100vh;
}

.p-button-sm {
    font-size: 0.7rem;

    padding: 0.4rem 0.8rem;
}

.bell {
    display: block;
    /* width: 40px;
  height: 40px; */
    /* font-size: 40px; */
    /* margin:50px auto 0; */
    color: #9e9e9e;
    -webkit-animation: ring 4s .7s ease-in-out infinite;
    -webkit-transform-origin: 50% 4px;
    -moz-animation: ring 4s .7s ease-in-out infinite;
    -moz-transform-origin: 50% 4px;
    animation: ring 4s .2s ease-in-out infinite;
    transform-origin: 50% 4px;
}

@-webkit-keyframes ring {
    0% {
        -webkit-transform: rotateZ(0);
    }

    1% {
        -webkit-transform: rotateZ(30deg);
    }

    3% {
        -webkit-transform: rotateZ(-28deg);
    }

    5% {
        -webkit-transform: rotateZ(34deg);
    }

    7% {
        -webkit-transform: rotateZ(-32deg);
    }

    9% {
        -webkit-transform: rotateZ(30deg);
    }

    11% {
        -webkit-transform: rotateZ(-28deg);
    }

    13% {
        -webkit-transform: rotateZ(26deg);
    }

    15% {
        -webkit-transform: rotateZ(-24deg);
    }

    17% {
        -webkit-transform: rotateZ(22deg);
    }

    19% {
        -webkit-transform: rotateZ(-20deg);
    }

    21% {
        -webkit-transform: rotateZ(18deg);
    }

    23% {
        -webkit-transform: rotateZ(-16deg);
    }

    25% {
        -webkit-transform: rotateZ(14deg);
    }

    27% {
        -webkit-transform: rotateZ(-12deg);
    }

    29% {
        -webkit-transform: rotateZ(10deg);
    }

    31% {
        -webkit-transform: rotateZ(-8deg);
    }

    33% {
        -webkit-transform: rotateZ(6deg);
    }

    35% {
        -webkit-transform: rotateZ(-4deg);
    }

    37% {
        -webkit-transform: rotateZ(2deg);
    }

    39% {
        -webkit-transform: rotateZ(-1deg);
    }

    41% {
        -webkit-transform: rotateZ(1deg);
    }

    43% {
        -webkit-transform: rotateZ(0);
    }

    100% {
        -webkit-transform: rotateZ(0);
    }
}

@-moz-keyframes ring {
    0% {
        -moz-transform: rotate(0);
    }

    1% {
        -moz-transform: rotate(30deg);
    }

    3% {
        -moz-transform: rotate(-28deg);
    }

    5% {
        -moz-transform: rotate(34deg);
    }

    7% {
        -moz-transform: rotate(-32deg);
    }

    9% {
        -moz-transform: rotate(30deg);
    }

    11% {
        -moz-transform: rotate(-28deg);
    }

    13% {
        -moz-transform: rotate(26deg);
    }

    15% {
        -moz-transform: rotate(-24deg);
    }

    17% {
        -moz-transform: rotate(22deg);
    }

    19% {
        -moz-transform: rotate(-20deg);
    }

    21% {
        -moz-transform: rotate(18deg);
    }

    23% {
        -moz-transform: rotate(-16deg);
    }

    25% {
        -moz-transform: rotate(14deg);
    }

    27% {
        -moz-transform: rotate(-12deg);
    }

    29% {
        -moz-transform: rotate(10deg);
    }

    31% {
        -moz-transform: rotate(-8deg);
    }

    33% {
        -moz-transform: rotate(6deg);
    }

    35% {
        -moz-transform: rotate(-4deg);
    }

    37% {
        -moz-transform: rotate(2deg);
    }

    39% {
        -moz-transform: rotate(-1deg);
    }

    41% {
        -moz-transform: rotate(1deg);
    }

    43% {
        -moz-transform: rotate(0);
    }

    100% {
        -moz-transform: rotate(0);
    }
}

@keyframes ring {
    0% {
        transform: rotate(0);
    }

    1% {
        transform: rotate(30deg);
    }

    3% {
        transform: rotate(-28deg);
    }

    5% {
        transform: rotate(34deg);
    }

    7% {
        transform: rotate(-32deg);
    }

    9% {
        transform: rotate(30deg);
    }

    11% {
        transform: rotate(-28deg);
    }

    13% {
        transform: rotate(26deg);
    }

    15% {
        transform: rotate(-24deg);
    }

    17% {
        transform: rotate(22deg);
    }

    19% {
        transform: rotate(-20deg);
    }

    21% {
        transform: rotate(18deg);
    }

    23% {
        transform: rotate(-16deg);
    }

    25% {
        transform: rotate(14deg);
    }

    27% {
        transform: rotate(-12deg);
    }

    29% {
        transform: rotate(10deg);
    }

    31% {
        transform: rotate(-8deg);
    }

    33% {
        transform: rotate(6deg);
    }

    35% {
        transform: rotate(-4deg);
    }

    37% {
        transform: rotate(2deg);
    }

    39% {
        transform: rotate(-1deg);
    }

    41% {
        transform: rotate(1deg);
    }

    43% {
        transform: rotate(0);
    }

    100% {
        transform: rotate(0);
    }
}

.card {
    cursor: pointer;
}
</style>